// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"479":"2c7337ca","539":"bd8a2dac","932":"1dc14aff"}[chunkId] + ".chunk.js";
};